import React from 'react';

export default function Evaluasi() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Evaluasi</h1>
      <p className="text-gray-500">Halaman Evaluasi</p>
    </div>
  );
}
